<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="ID" :value="1"></el-option>
                            <el-option label="名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.dateType" slot="prepend" placeholder="请选择">
                                <el-option label="生效时间" :value="1"></el-option>
                                <el-option label="截止时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="params.date"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="addCoupon">创建优惠券</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID" :min-width="110"></el-table-column>
                <el-table-column prop="name" label="名称" :min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="couponPrice" label="金额" :min-width="110"></el-table-column>
                <el-table-column label="有效期" :min-width="300">
                    <template slot-scope="scope">
                        {{`${scope.row.beginTime} 至 ${scope.row.endTime}`}}
                    </template>
                </el-table-column>
                <el-table-column label="补贴承担" :min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.subsidyUser === 0">秀动平台</span>
                        <span v-else>{{scope.row.subsidyUserType | typeFormat}} - {{scope.row.subsidyUserName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="领取地址">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini"> <el-link :href="scope.row.link" target="_blank">打开</el-link> </el-button>
                        <el-button type="text" size="mini" @click="copy(scope.row.link)">复制</el-button>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" :width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="manage(scope.row)" >管理</el-button>
                        <el-button type="text" size="small" @click="delConfirm(scope.row)" >删除</el-button>
                        <el-button type="text" size="small" @click="issue(scope.row)" >发放</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <CouponManage ref="couponManage" @submitSuccess="getDataList" @confirm="manageConfirm"></CouponManage>
        <UpdateConfirm ref="updateConfirm" @submitSuccess="getDataList"></UpdateConfirm>
        <DeleteConfirm ref="deleteConfirm" @submitSuccess="getDataList"></DeleteConfirm>
        <CouponIssue ref="couponIssue" @submitSuccess="issueSuccess"></CouponIssue>
        <input class="copyTool" ref="copyTool" :value="copyUrl" />
    </div>
</template>

<script>
import CouponManage from './components/CouponManage'
import UpdateConfirm from './components/UpdateConfirm'
import DeleteConfirm from './components/DeleteConfirm'
import CouponIssue from './components/CouponIssue'

export default {
    components:{CouponManage, UpdateConfirm, DeleteConfirm, CouponIssue},
    filters:{
        typeFormat(type) {
            return {1: '乐迷', 2: '艺人', 3: '场地', 5: '厂牌'}[type];
        }
    },
    data(){
        this.defaultParams = {
            // 查询类型 1：ID 2：名称
            type: 1,
            value: null,
            // 时间类型，1：生效时间 2：截止时间
            dateType: 1,
            date: null,
            pageNo: 1,
            pageSize: this.$pageSizes[0]
        };

        return {
            data: [],
            dataList: [],
            params:{
                ...this.defaultParams,
                type: parseInt(this.$route.query.type || 1),
                value: this.$route.query.value || null,
                dateType: parseInt(this.$route.query.dateType || 1),
                date: this.$route.query.startDate && this.$route.query.endDate ? [this.$route.query.startDate, this.$route.query.endDate] : null,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
            copyUrl: "",
            copyTimer: null
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {
            const {date, ...filterData} = this.params;
            const [startDate, endDate] = date || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/coupon/goods/list',
                method: 'post',
                data: {...filterData, startDate, endDate}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
            this.dataList.map(item => {
                item.link = `${this.sswap}/pages/coupon/receive/receive?id=${item.code}&type=3`
            })
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...this.defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        // 创建优惠券
        addCoupon() {
            this.$refs.couponManage.show();
        },
        // 管理
        manage(row) {
            this.$refs.couponManage.show(row);
        },
        // 管理确认
        manageConfirm(data) {
            this.$refs.updateConfirm.show(data);
        },
        // 删除确认
        async delConfirm(row) {
            const {id} = row;

            const flag = await this.$confirm('确定要删除该优惠券吗?', '确认删除', {
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).catch(() => {
                return 'cancel';
            });

            if(flag === 'cancel') {
                return;
            }

            // 验证优惠券是否存在已经被用户领取
            const res = await this.$request({
                url: '/coupon/goods/validate',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }
            
            // 二次确认
            if(result.unUseCount > 0) {
                this.$refs.deleteConfirm.show(id);
                return ;
            }

            // 删除请求
            this.del(id);
        },
        // 删除
        async del(id) {
            const res = await this.$request({
                url: '/coupon/goods/delete',
                method: 'post',
                data: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });

            const { state, msg } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }

            this.getDataList();
        },
        // 发放
        issue(row) {
            this.$refs.couponIssue.show(row);
        },
        async issueSuccess() {
            await this.$alert('发放完成', '提示', {
                confirmButtonText: '确认',
                type: 'success',
                center: true
            });

            this.getDataList();
        },
        //复制链接
        copy(url){
            clearTimeout(this.copyTimer);
            this.copyUrl = url;
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
        
    }
}
</script>


<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>